import { backendAPI } from 'services/backendAPI';
import { REQUEST_FEATURE_RESOURCE_NAME } from 'services/resources/apiConstants';

export const requestFeature = (data) => {
  return backendAPI.post(REQUEST_FEATURE_RESOURCE_NAME, data);
};
